import React from 'react';
const ContentContext = React.createContext({
	blur: false,
	animations: true,
	doBlur: () => {},
	undoBlur: () => {},
	stopAnimations: () => {},
	startAnimations: () => {},
});
export default ContentContext;